
// helpers
import getLimitOffset from "@/helpers/getLimitOffset";
import dayjs from "@/helpers/dayjs";


export const PAGE_SIZE = 12;

export const PAGE_SIZES_OPTIONS = [
  { value: 10, label: 10 },
  { value: 20, label: 20 },
  { value: 30, label: 30 },
  { value: 60, label: 60 },
];

export const DEFAULT_SEARCH_PARAMS = {
  page: 1,
  pageSize: 20,
  ordering: "-high_to_low"
};

export const SORT_BY_OPTIONS = [
  { id: "1", label: "Avg. cost: High to Low", value: "-high_to_low" },
  { id: "2", label: "Avg. cost: Low to High", value: "daily_price" },
  { id: "3", label: "Highest footfall", value: "-weekly_footfall" },
  { id: "4", label: "Highest spend", value: "-spending" },
  { id: "5", label: "Highest dwell time", value: "-dwell_time" },
  { id: "6", label: "Newest locations", value: "published_days" },
  { id: "6", label: "Newest spaces", value: "published_days_spaces" },
  { id: "7", label: "Highest male %", value: "-male" },
  { id: "8", label: "Highest female %", value: "-female" }
];

export const transformSearchParams = (params: { [key: string]: string | null }) => {
  const {
    width__gte,
    length__gte,
    size__in,
    start_date,
    end_date,
    when__in,
    purpose__in,
    city__in,
    type__in,
    except_facet,
    collections__in,
    popular_searches__in,
    rate_daily__range,
    weekly_footfall__range,
    spending__range,
    dwell_time__range,
    abc1__range,
    gen_z__range,
    gen_y__range,
    gen_x__range,
    baby_boomer__range,
    male__range,
    environments,
  } = params;

  const sizeCustom = (width__gte || length__gte)
    ? { width: width__gte, length: length__gte }
    : null;
  const date = start_date && end_date
    ? [
      dayjs(start_date),
      dayjs(end_date),
      when__in
    ]
    : null;

  return {
    date,
    sizeCustom,
    purpose__in: +(purpose__in as string) || null,
    size__in: (!width__gte && !length__gte) ? size__in?.split("__") : null,
    city__in: city__in?.split("__").map(Number),
    type__in: type__in?.split("__").map(Number),
    except_facet,
    collections__in,
    popular_searches__in,
    rate_daily__range,
    weekly_footfall__range,
    spending__range,
    dwell_time__range,
    abc1__range,
    gen_z__range,
    gen_y__range,
    gen_x__range,
    baby_boomer__range,
    male__range,
    environments
  };
}

export const buildRequestQuery = (params: { [key: string]: string }) => {
  const { page, pageSize, ...queryParams } = params;
  const { offset, limit } = getLimitOffset({ page: +page, pageSize: +pageSize });

  return {
    ...queryParams,
    size__in: +queryParams.purpose__in !== 4 ? queryParams.size__in : null,
    type__in: +queryParams.purpose__in !== 4 ? queryParams.type__in : null,
    limit,
    offset,
  };
};
